window.o_order.basket.basketSwipeToDeleteHandler = function (deleteItemFn) {
    const wrapper = '.order_js_basketItem-swipe-wrapper';
    const innerWrapper = '.order_js_basketItem-swipe-inner';
    const deleteButtonClass = '.order_js_basketItem-swipe-delete-button';
    const basketItem = '.order_js_item';

    function addSwipeListeners() {
        const allSwipeableItems = Array.from(document.querySelectorAll(wrapper));
        allSwipeableItems.forEach(item => {
            let isInteracting = false;
            let scrollTimer = null;

            const scheduleCheck = () => {
                clearTimeout(scrollTimer);
                scrollTimer = setTimeout(() => {
                    if (isInteracting) {
                      return;
                    }

                    const itemToDelete = item.closest(wrapper);
                    if (!itemToDelete) {
                      return;
                    }

                    const { scrollLeft } = item;
                    const width = itemToDelete.offsetWidth;

                    if (Math.abs(scrollLeft - width) <= 5) {
                        removeItem(itemToDelete, 'SwipeFull');
                    }
                }, 100);
            };

            item.addEventListener('scroll', () => {
                if (!isInteracting) {scheduleCheck();}
            });

            item.addEventListener('touchend', () => {
                isInteracting = false;
                scheduleCheck();
            });

            item.addEventListener('touchstart', () => {
                isInteracting = true;
                if (scrollTimer) {clearTimeout(scrollTimer);}
                allSwipeableItems
                    .filter(element => element !== item)
                    .forEach(i => {
                        i.scrollTo(0, 0);
                    });
            });
        });
    }

    function addDeleteListeners() {
        const allDeleteButtons = Array.from(document.querySelectorAll(deleteButtonClass));
        allDeleteButtons.forEach(deleteButton => {
            const itemToDelete = deleteButton.closest(wrapper);
            if (itemToDelete) {
                deleteButton.addEventListener('click', () => {
                    removeItem(itemToDelete, "SwipeHalf");
                });
            }
        });
    }

  /*🤫
🤫
🤫
🤫*/
    function removeItem(itemToDelete, interactionType) {
        const itemElement = itemToDelete.querySelector(basketItem);
        const itemId = itemElement?.dataset.basketitemid;
        if (!itemId) {
            return;
        }

        deleteItemFn(itemId, interactionType);
        collapseBasketItem(itemToDelete);
    }

    /*🤫*/
    function collapseBasketItem(itemToDelete) {
        const sectionHeight = itemToDelete.scrollHeight;
        const inner = itemToDelete.querySelector(innerWrapper);
        requestAnimationFrame(() => {
            itemToDelete.style.height = sectionHeight + 'px';
            itemToDelete.style.transition = 'height 0.2s ease-out';
            inner && (inner.style.display = 'none');
            requestAnimationFrame(() => {
              itemToDelete.style.height = '0px';
            });
        });
    }
    /*🤫*/

    if (!deleteItemFn) {
        return;
    }

    addSwipeListeners();
    addDeleteListeners();
}